import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { EmailRecipientSearchService } from '../email-recipient-search.service';
import { FilterService } from '../../../../../../Common/Filter/services/abstract-filter.service';
import { EmailRecipientModel } from '../../../../../../Common/TargetingShared/model/statisticsReport/email-recipient.model';
import { FilterGroupModel } from '../../../../../../Common/Filter/models/filter-group.model';

@Component({
    selector: 'agpr-email-recipient-toolbar',
    templateUrl: './email-recipient-toolbar.component.html',
    styleUrls: ['./email-recipient-toolbar.component.scss'],
    providers: [
        {
            provide: 'PaginatorServiceInterface',
            useExisting: EmailRecipientSearchService
        },
        {
            provide: FilterService,
            useExisting: EmailRecipientSearchService
        },
        {
            provide: 'SortOrderServiceInterface',
            useExisting: EmailRecipientSearchService
        }
    ],
    standalone: false
})
export class EmailRecipientToolbarComponent implements OnDestroy {

    results: EmailRecipientModel[];
    totalResults: number;
    loading = false;
    chipsVisible = false;

    private subscriptions: Subscription[] = [];

    constructor(
        public emailRecipientSearchService: EmailRecipientSearchService
    ) {
        this.subscriptions.push(
            this.emailRecipientSearchService.results$.subscribe(results => {
                this.results = results;
            }),
            this.emailRecipientSearchService.getItemCount().subscribe(total => this.totalResults = total),
            this.emailRecipientSearchService.getFilters().subscribe(filters => {
                this.chipsVisible = !!filters.find(filter => {
                    if (filter instanceof FilterGroupModel) {
                        return filter.children.find(x => x.chips && x.chips.length > 0);
                    } else {
                        return filter.chips && filter.chips.length > 0;
                    }
                });
            }),
            this.emailRecipientSearchService.getPageCriteria().subscribe(pageCriteria => null),
            this.emailRecipientSearchService.searchLoading$.subscribe(loading => this.loading = loading),
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach(
            subscription => subscription.unsubscribe()
        );
    }
}
